/**
 * ChartOptionType is separate from VisualizationType because it may be more granular than VisualizationType.
 * For example, we allow users to choose between a grouped or stacked bar chart, which both fall under the
 * general VisualizationType.BAR_CHART.
 */
export enum ChartOptionType {
  TABLE = 'Table',
  GROUPED_BAR = 'Vertical grouped bar chart',
  STACKED_BAR = 'Vertical stacked bar chart',
  LINE = 'Line chart',
  PIE = 'Pie chart',
  SCATTER = 'Scatter plot',
  HEATMAP = 'Heatmap',
  REGRESSION = 'Regression',
  BOXPLOT = 'Boxplot',
}

/**
 * AnalysisVisualizationType is a superset of VisualizationType.
 * With the release of box plots, the analysis tool started supporting chart types that are not supported in
 * the insights dashboard. Additionally, new chart types do not have a visualizationConfig backed by a
 * AnalyticsVisualizationNode assosciated with them, only the stepConfig.
 *
 * The original analysis tool ChartView and EditChartView components assume that all chart types have
 * visualizationConfigs, so we will use VisualizationType for some parts of those components and their helpers
 * until they are removed with the full release of ENABLE_ANALYSIS_TOOL_LAYOUTS_AND_VIEWS_REDESIGN.
 */
export enum AnalysisVisualizationType {
  BAR_CHART = 'BAR_CHART',
  HEATMAP = 'HEATMAP',
  LINE_CHART = 'LINE_CHART',
  PIE_CHART = 'PIE_CHART',
  SCATTER_PLOT = 'SCATTER_PLOT',
  TABLE = 'TABLE',
  BOX_PLOT = 'BOX_PLOT',
}
